import { createApp } from 'vue'
import VueTilt from 'vue-tilt.js'
import router from './config/router'
import { createUsersState, usersSymbol } from './stores/users'
import App from './App.vue'
import './assets/styles/tailwind.css'
import './clipboard'

const app = createApp(App,)
app.use(router)
app.use(VueTilt)
app.provide(usersSymbol, createUsersState())
app.mount('#app')
app.config.devtools = true
